export const AppRoutePathnames = {
  DEFAULT: '/',
  HOME: '/home',
  HEROES: '/heroes',
  ABOUT: '/about',
  ANY: '*',
};

export const AppRouteNames = {
  [AppRoutePathnames.HOME]: 'Home',
  [AppRoutePathnames.HEROES]: 'Heroes',
  [AppRoutePathnames.ABOUT]: 'About',
};
